module.exports = __webpack_public_path__ + "img/zuoyebang-propa.d5c90f90.png";